import { PropsWithChildren } from 'react'
import css from './flyingRocketLayput.module.css'
import FirstRocketSrc from '../../../asserts/rockets/FirstRocket.png'

const FlyingRocketLayout = (props: PropsWithChildren) => {
  return (
    <div className={css.wrapper}>
      <img src={FirstRocketSrc} className={css.firstRocket} alt="First-rocket" />
      {props.children}
    </div>
  )
}

export default FlyingRocketLayout
